import React from 'react';
import { motion } from 'framer-motion';
import { ChevronRight } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'danger';
  size?: 'sm' | 'md' | 'lg';
  fullWidth?: boolean;
  withIcon?: boolean;
}
export function Button({
  children,
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  withIcon = true,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'relative inline-flex items-center justify-center font-bold uppercase tracking-wider transition-all duration-300 overflow-hidden group';
  const variants = {
    primary: 'bg-[#00d9ff] text-[#0a0e1a] hover:bg-white hover:shadow-[0_0_20px_rgba(0,217,255,0.6)]',
    secondary: 'bg-transparent border-2 border-[#00d9ff] text-[#00d9ff] hover:bg-[#00d9ff]/10',
    danger: 'bg-[#ff3366] text-white hover:bg-[#ff1a53] hover:shadow-[0_0_20px_rgba(255,51,102,0.6)]'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg md:text-xl'
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${fullWidth ? 'w-full' : ''} ${className}`} {...props} data-id="element-290">
      {/* Tech glitch effect overlay */}
      <span className="absolute inset-0 w-full h-full bg-white/20 -translate-x-full group-hover:animate-[shimmer_1.5s_infinite] skew-x-12" data-id="element-291" />

      <span className="relative flex items-center gap-2" data-id="element-292">
        {children}
        {withIcon && <ChevronRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-293" />}
      </span>
    </motion.button>;
}